import page3bg from '../../assets/page-dark-bg.png'

const ReportLoading = () => {
  return (
    <div
      className={'bg-image-config'}
      style={{
        textAlign: 'center',
        height: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${page3bg})`,
      }}
    >
      <p className={'inverted-text subtitle'}>Loading...</p>
    </div>
  )
}

export default ReportLoading
